import UserTypes from 'store/actionTypes/user'
import VehicleModelTypes from 'store/actionTypes/vehicleType'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  systems: []
}

const vehicleType = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case VehicleModelTypes.GET_VEHICLE_TYPES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case VehicleModelTypes.GET_VEHICLE_TYPE_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case VehicleModelTypes.UPDATE_FILTER_VEHICLE_TYPE_SUCCESS:
      return { ...state, filter: payload }
    case VehicleModelTypes.CLEAR_FILTER_VEHICLE_TYPE_SUCCESS:
      return { ...state, filter: initialData.filter }
    case VehicleModelTypes.GET_SYSTEM_VEHICLE_TYPES_SUCCESS:
      return { ...state, systems: payload?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}
export default vehicleType
